<template>
  <div>
    <div
      class="goodsManageSet"
      :class="{ fixedStyle: isShowStyle }"
      :style="{ top: scrollTop + 'px' }"
    >
      <div class="main_content">
        <div class="tit">新增（编辑）商品配件</div>
        <div class="block" v-if="false">
          <h1>属性标签缩略图</h1>
          <p class="red">JPG或者PNG格式，尺寸比例为500*500像素</p>
          <div class="img_box">
            <van-uploader
              v-model="fileList"
              @delete="deleteImg(1)"
              :before-read="beforeRead"
              :after-read="afterRead"
              :max-count="1"
            />
          </div>
        </div>

        <div class="block">
          <h1><span class="mark">*</span>请输入配件商品的SKU编码</h1>
          <div class="input_box flex-between">
            <van-field
              v-model="formData.cmsku"
              placeholder="请设置配件商品SKU"
              :readonly="formData.id && formData.id != ''"
            />
          </div>
        </div>
        <div class="block">
          <h1><span class="mark">*</span>每件配套数量</h1>
          <div class="input_box flex-between">
            <van-field
              v-model="formData.num"
              placeholder="请设置每件配套数量"
            />
          </div>
        </div>

        <div class="block">
          <h1><span class="mark">*</span>是否额外收费？</h1>
          <div class="radio_box">
            <van-radio-group
              direction="horizontal"
              v-model="formData.isaddprice"
              style="justify-content: space-evenly"
              @change="handlePriceType"
            >
              <van-radio name="1">是</van-radio>
              <van-radio name="0">否 </van-radio>
            </van-radio-group>
          </div>
        </div>
        <div class="block" v-if="formData.isaddprice != ''">
          <h1><span class="mark">*</span>额外收费价格</h1>
          <div class="input_box flex-between">
            <van-field
              v-model="formData.price"
              placeholder="请设置价格"
              @input="handleInputPrice"
              :readonly="formData.isaddprice == 0"
            />
          </div>
        </div>
        <div class="block">
          <h1><span class="mark">*</span>是否启用</h1>
          <div class="radio_box">
            <van-radio-group
              direction="horizontal"
              v-model="formData.isuse"
              style="justify-content: space-evenly"
            >
              <van-radio name="1">启用</van-radio>
              <van-radio name="0">停用 </van-radio>
            </van-radio-group>
          </div>
        </div>
      </div>

      <div class="primary-button" @click="query">保存确认</div>

      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i>返回
      </div>
    </div>

    <van-popup v-model="isShow" round position="bottom" class="brandPopup">
      <template v-if="popupType == 1">
        <van-picker
          title="请选择属性标签"
          show-toolbar
          :columns="attrList"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </template>
      <template v-if="popupType == 2">
        <van-picker
          title="请选择标签值"
          show-toolbar
          :columns="attrValueList"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </template>
    </van-popup>
  </div>
</template>

<script>
import {
  getAttrLabelList,
  getAttrLabelValue,
  uploadImage,
} from "../../../api/api";
import {
  getShopAttachmentDetail,
  addShopAttachmentl,
  editShopAttachmentl,
} from "../../../api/shop";
export default {
  name: "cShopAttachmentSet",
  data() {
    return {
      radio: "",
      searchText: "",
      isShowStyle: false,
      scrollTop: 0,

      // 弹窗
      popupType: 1,
      isShow: false,
      attrList: [],
      attrValueList: [],

      attrId: "",
      firstIndex: "",
      secondIndex: "",
      fileList: [],

      id: "", // 属性id
      attrName: "", // 属性标签
      labelNum: "", // 商品价格
      labeltype: "", // 商品类型
      formData: {
        cmid: "", // 商品id
        cmsku: "", // 配件商品SKU
        num: "", // 每件配套数量
        isaddprice: "", // 是否增加价格 =1=是 0=否
        price: "",
        isuse: "", // 是否启用 =1=启用 0=停用
        pei_qyguid: "",
      },
    };
  },
  created() {
    let { cmId, id, cmSku } = this.$route.query;
    this.formData.cmid = cmId;
    console.log(cmSku, "===");
    // this.formData.cmsku = cmSku;
    this.formData.pei_qyguid = this.$store.state.USERINFO.qy
      ? this.$store.state.USERINFO.qy.qyguid
      : "";
    this.id = id;
    if (id) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      let { id } = this.$route.query;
      getShopAttachmentDetail({ id }).then((res) => {
        this.formData.id = res.id;
        this.formData.cmsku = res.cmsku;
        this.formData.num = res.num;
        this.formData.isaddprice = res.isaddprice;
        this.formData.price = res.price;
        this.formData.isuse = res.isuse;
        Toast.clear();
      });
    },

    handlePopup(type) {
      let { attrList, attrName } = this;
      this.popupType = type;
      if (type == 1) {
        if (attrList.length == 0) {
          this.$toast("暂无属性标签");
          return;
        }
        this.isShow = true;
      } else if (type == 2) {
        if (attrName == "") {
          this.$toast("请选择属性标签");
          return;
        }
        this.isShow = true;
      }
    },

    // 显示弹窗
    onConfirm(e) {
      let { popupType } = this;
      let { value, text } = e;
      if (popupType == 1) {
        this.attrName = text;
        this.formData.attrid = value;
        this.formData.attrvalue = "";
        // this.getAtrrValueList(value);
      } else if (popupType == 2) {
        this.formData.attrvalue = value;
      }
      this.isShow = false;
    },

    // 获取属性标签
    getAtrrList(attrid) {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getAttrLabelList().then((res) => {
        let newArr = [];
        res.forEach((v) => {
          if (attrid == v.id) {
            this.formData.attrid = attrid;
            this.attrName = v.attrname;
          }
          newArr.push({
            text: v.attrname,
            value: v.id,
          });
        });
        if (attrid) {
          this.getAtrrValueList(attrid);
        }
        this.attrList = newArr;
        Toast.clear();
      });
    },
    // 获取属性标签值
    getAtrrValueList(attrid) {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getAttrLabelValue().then((res) => {
        let newArr = [];
        res.forEach((v) => {
          if (v.attrid == attrid) {
            newArr.push({
              text: v.attrvalue,
              value: v.attrvalue,
            });
          }
        });

        this.attrValueList = newArr;
        Toast.clear();
      });
    },
    // 价格变动
    handleNumType(event) {
      let { numtype } = this.formData;
      let { labelNum, labeltype } = this;
      if (event == "不变") {
        this.formData.num = 0;
      } else {
        if (labeltype == numtype && labelNum != "") {
          this.formData.num = labelNum;
        } else if (labeltype == numtype && labelNum != "") {
          this.formData.num = labelNum;
        } else {
          this.formData.num = "";
        }
      }
    },

    // 获得焦点
    inputFocus(e) {
      this.scrollTop = "-" + (e.srcElement.getBoundingClientRect().top - 200);
      this.isShowStyle = true;
    },
    // 失去焦点
    inputBlur() {
      this.isShowStyle = false;
    },
    // 输入框限制
    handleInput(event) {
      // 只允许输入数字和小数点
      let value = event.replace(/[^\d.]/g, "");
      // 限制只能输入一个小数点
      value = value.replace(/^\./, "").replace(/\.{2,}/g, ".");
      // 截取小数点后两位
      value = value.replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      this.formData.num = value;
    },
    handleReturn() {
      history.back();
    },

    // 删除图片
    deleteImg() {
      this.formData.logo = "";
    },
    // 图片上传之前处理
    beforeRead(file) {
      const imgformat = /image\/(png|jpg|jpeg)$/;
      if (!imgformat.test(file.type)) {
        this.$toast.fail("请上传 jpg/png 格式图片");
        return false;
      }
      return true;
    },
    // 检测图片的宽高
    checkWidthAndHeight(file) {
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = function () {
          let width = img.width;
          var height = img.height;
          if (width == 500 && height == 500) {
            reject(true);
          } else {
            resolve(false);
          }
        };
      });
    },
    // 图片上传后处理
    afterRead(e) {
      var formData = new FormData();
      formData.append("imgfile", e.file);
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      uploadImage(formData).then((res) => {
        if (res.result) {
          this.formData.pic = res.url;
        }
        Toast.clear();
      });
    },
    // 输入框限制
    handleInputPrice(event) {
      // 只允许输入数字和小数点
      let value = event.replace(/[^\d.]/g, "");
      // 限制只能输入一个小数点
      value = value.replace(/^\./, "").replace(/\.{2,}/g, ".");
      // 截取小数点后两位
      value = value.replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      this.formData.price = value;
    },
    handlePriceType(e) {
      if (e == 0) {
        this.formData.price = 0;
      } else {
        this.formData.price = "";
      }
    },

    query() {
      let { formData, id } = this;
      // formData.pic = this.imgSplit(formData.pic);
      let params = formData;
      if (formData.cmid == "") {
        this.$toast("请填写配件商品SKU");
        return false;
      }
      if (formData.num == "") {
        this.$toast("请填写每件配套数量");
        return false;
      }
      if (formData.isaddprice == "") {
        this.$toast("请选择是否增加价格");
        return false;
      }
      if (formData.price === "") {
        this.$toast("请填写价格");
        return false;
      }
      if (formData.isuse == "") {
        this.$toast("请选择是否启用");
        return false;
      }
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      if (id) {
        params.id = id;
        editShopAttachmentl(params).then((res) => {
          let data = res;
          if (data.result) {
            setTimeout(() => {
              Toast.clear();
              this.$toast.success(data.message);
            }, 500);
            // setTimeout(() => {
            //   history.back();
            // }, 1500);
          } else {
            this.$toast.fail(data.message || "服务器报错，请稍后～");
          }
        });
      } else {
        addShopAttachmentl(params).then((res) => {
          let data = res;
          if (data.result) {
            // setTimeout(() => {
            //   Toast.clear();
            //   this.$toast.success(data.message);
            // }, 2000);
            setTimeout(() => {
              Toast.clear();
              history.back();
            }, 500);
          } else {
            this.$toast.fail(data.message || "服务器报错，请稍后～");
          }
        });
      }
    },
    // 图片路径的分割
    imgSplit(url) {
      if (url != "" && url) {
        if (url.indexOf("upload")) {
          let splitArr = url.split("/upload/");
          return splitArr[splitArr.length - 1];
        } else if (url.indexOf("Upload")) {
          let splitArr = url.split("/Upload/");
          return splitArr[splitArr.length - 1];
        }
      } else {
        return "";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-top: 120px;
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .main_content {
    .tit {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .block {
      margin-bottom: 80px;
      h1 {
        text-align: center;
        font-weight: 400;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .img_box {
        margin: auto;
        margin-top: 40px;
        text-align: center;
      }
      p {
        font-size: 22px;
        text-align: center;
        &.red {
          color: #ff0012;
        }
      }
    }
  }
}
</style>